import React from 'react';
import { Connection } from '../style';

function ConnectionLine(props) {
  const { connection: { start, end, energy: { direction, isSourceNode } = {} } = {}, showEnergyFlow } = props;

  return (
    <svg>
      <Connection
        data-styled={{
          showEnergyFlow: showEnergyFlow && !!direction && direction !== 'UNSPECIFIED',
          reverseDirection: direction === 'OUT',
          isSourceNode,
        }}
        d={`M ${start.x} ${start.y} L ${end.x} ${end.y}`}
      />
    </svg>
  );
}

export default ConnectionLine;
